import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatLineModule } from "@angular/material/core";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

import { DragDropModule } from "@angular/cdk/drag-drop";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenAssetLocationSelectionModule } from "../../shared/modules/loren-asset-location-selection/loren-asset-location-selection.module";
import { LorenCardModule } from "../../shared/modules/loren-card/loren-card.module";
import { LorenHierarchySelectorModule } from "../../shared/modules/loren-hierarchy-selector/loren-hierarchy-selector.module";
import { LorenEntityDeleteCardModule } from "../../shared/modules/loren-entity-delete-card/loren-entity-delete-card.module";
import { LorenEntityFormCardModule } from "../../shared/modules/loren-entity-form-card/loren-entity-form-card.module";
import { LorenEntityFormModule } from "../../shared/modules/loren-entity-form/loren-entity-form.module";
import { LorenFileUploadModule } from "../../shared/modules/loren-file-upload/loren-file-upload.module";
import { LorenKeyValueControlModule } from "../../shared/modules/loren-key-value-control/loren-key-value-control.module";
import { LorenLineChartModule } from "../../shared/modules/loren-line-chart/loren-line-chart.module";
import { LorenPeriodSelectorFormModule } from "../../shared/modules/loren-period-selector-form/loren-period-selector-form.module";
import { LorenPeriodSelectorModule } from "../../shared/modules/loren-period-selector/loren-period-selector.module";

import { LorenDatePipe } from "../../shared/pipes/loren-date/pipes/loren-date.pipe";
import { LorenDateModule } from "../../shared/pipes/loren-date/loren-date.module";
import { LorenImageModule } from "../../shared/pipes/loren-image/loren-image.module";

import { LorenAllAssetResolver } from "./resolvers/loren-asset-all.resolver";
import { LorenAssetResolver } from "./resolvers/loren-asset.resolver";
import { LorenAssetTypeResolver } from "./resolvers/loren-asset-type.resolver";
import { LorenAssetFormService } from "./services/loren-asset-form-service/loren-asset-form.service";
import { LorenAssetTypeService } from "./services/loren-asset-type-service/loren-asset-type.service";
import { LorenSharedDirectivesModule } from "../../shared/directives/loren-shared-directives.module";

@NgModule({
  providers: [
    LorenAssetResolver,
    LorenAssetTypeResolver,
    LorenAllAssetResolver,
    LorenAssetFormService,
    LorenAssetTypeService,
    LorenDatePipe,
  ],
  imports: [
    CommonModule,
    FormsModule,

    DragDropModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatLineModule,
    MatListModule,
    MatSelectModule,
    MatSnackBarModule,
    MatStepperModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    TranslocoModule,

    LorenAssetLocationSelectionModule,

    LorenCardModule,
    LorenDateModule,
    LorenEntityDeleteCardModule,
    LorenEntityFormCardModule,
    LorenEntityFormModule,
    LorenFileUploadModule,
    LorenHierarchySelectorModule,
    LorenImageModule,
    LorenKeyValueControlModule,
    LorenLineChartModule,
    LorenPeriodSelectorFormModule,
    LorenPeriodSelectorModule,
    LorenSharedDirectivesModule,
    ReactiveFormsModule,
  ],
})
export class LorenAssetsModule {}
